export interface ArticleMetadata {
    id: string;
    title: string;
    description: string;
    date: string;
    category: string;
    tags: string[];
    imageUrl?: string;
  }
  
  export const articlesMetadata: ArticleMetadata[] = [
    {
      id: 'POE2-Classes-Guide',
      title: 'POE2 T0 Classes and Ascendancies Recommendation',
      description: 'A comprehensive guide to Path of Exile 2 classes and ascendancies, including rankings and recommendations for beginners.',
      date: '2025-01-11',
      category: 'Guides',
      tags: ['classes', 'ascendancies', 'beginner guide', 'tier list']
    },
    {
      id: 'POE2-One-Month-Tips',
      title: 'Path of Exile 2: One Month In – Essential Tips for Beginners',
      description: 'Essential tips and strategies for beginners after one month of POE2 release, covering skills, exploration, gear, and more.',
      date: '2025-01-12',
      category: 'Guides',
      tags: ['beginner guide', 'tips', 'gameplay', 'progression']
    },
    {
      id: 'POE2-Demon-Hunter-Guide',
      title: 'Path of Exile 2: The Ultimate Beginner\'s Guide to the Demon Hunter Build',
      description: 'A comprehensive beginner\'s guide to mastering the Demon Hunter build in Path of Exile 2, covering skills, progression, and gear strategies.',
      date: '2025-01-13',
      category: 'Builds',
      tags: ['demon hunter', 'beginner guide', 'build guide', 'class guide']
    },
    {
      id: 'POE2-Druid-Guide',
      title: 'Path of Exile 2: Ultimate Druid Build Guide - Shapeshifting & Elemental Mastery',
      description: 'A comprehensive guide to mastering the Druid class in Path of Exile 2, focusing on shapeshifting mechanics and elemental damage optimization.',
      date: '2025-01-14',
      category: 'Guides',
      tags: ['druid', 'beginner guide', 'build guide', 'shapeshifting'],
    },
    {
      id: 'POE2-Essence-System',
      title: 'Path of Exile 2: Complete Guide to the New Essence System',
      description: 'A comprehensive breakdown of PoE2\'s revolutionary Essence system, covering mechanics, acquisition, and strategic implications.',
      date: '2025-01-15',
      category: 'Guides',
      tags: ['essence', 'mechanics', 'game systems', 'beginner guide']
    },
    {
      id: 'POE2-Skill-System-Guide',
      title: 'Mastering the Art of Combat: The Evolved Skill System in Path of Exile 2',
      description: 'A comprehensive guide to Path of Exile 2\'s revamped skill system, covering skill gems, combat mechanics, and build strategies.',
      date: '2025-01-18',
      category: 'Guides',
      tags: ['skills', 'combat', 'mechanics', 'beginner guide', 'game systems']
    },
    {
      id: 'POE2-Witch-Hunter-AI-Build',
      title: 'Letting AI Build My Witch Hunter in POE2: Surprising Results!',
      description: 'An exploration of using AI to build a Witch Hunter in Path of Exile 2, with surprising results.',
      date: '2025-01-21',
      category: 'AI',
      tags: ['witch hunter', 'ai', 'build', 'beginner guide']
    },
    {
      id: 'POE2-Passive-Tree',
      title: 'Bro, This Tree Makes POE1 Look Like a Sapling',
      description: 'Path of Exile 2 Tree reshapes ARPGs: weapon-swap builds on the fly, craft frost/chaos hybrids via Path of Build Online, optimize endgame with Atlas Planner. Respec cheaply—turn "1HP glass cannon" into Reddit legend. GGG\'s chaos, perfected.',
      date: '2025-01-29',
      category: 'Guides',
      tags: ['passive tree', 'mechanics', 'game systems']
    },
    {
      id: 'POE2-0.2.0-Update',
      title: 'Path of Exile 2 0.2.0: A New Hunt Dawns - What to Expect and How to Prepare',
      description: 'A detailed look at the upcoming PoE2 0.2.0 update, what to expect, and how to prepare for the new content.',
      date: '2025-03-22',
      category: 'News',
      tags: ['update', 'guide', 'preparation', 'poe2', '0.2.0'],
    }
  ];